/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ComponentData, ComponentModel, ComponentFieldKey } from '../model/component.model';
import { ViewComponentKey } from '../key/view-component.key';

export interface ImageData extends ComponentData {
  source?: string;
}

export class ImageFieldKey {
  static readonly SOURCE = 'source';
}

export class ImageModel extends ComponentModel implements ImageData {
  static readonly KEYS = ComponentModel.KEYS.concat(
    Object.keys(ImageFieldKey).map((key) => ImageFieldKey[key])
  );

  constructor(data?: ImageData) {
    super(data, ImageModel.KEYS);
  }

  get source(): string {
    return this.get(ImageFieldKey.SOURCE);
  }

  set source(value: string) {
    this.set(ImageFieldKey.SOURCE, value);
  }

  protected setupValues(values: ImageData, exclusive: boolean): ImageData {
    if (exclusive && !(ComponentFieldKey.TYPE in values)) {
      values.type = ViewComponentKey.IMAGE;
    }
    return super.setupValues(values, exclusive) as ImageData;
  }
}
